import {Injectable} from '@angular/core';
import {BaseDialogService} from '../../base/src/base-dialog.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {EditAttachmentComponent} from './edit-attachment.component';

@Injectable({
  providedIn: 'root'
})
export class EditAttachmentDialogService extends BaseDialogService<EditAttachmentComponent, any> {

  protected config: MatDialogConfig = {
    width: '50vw'
  };

  constructor(protected matDialog: MatDialog) {
    super(matDialog, EditAttachmentComponent);
  }


}
